export class TableRetentionConfig {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "snapshotRetentionTime",
            "baseName": "snapshotRetentionTime",
            "type": "string",
            "format": ""
        },
        {
            "name": "snapshotMinCount",
            "baseName": "snapshotMinCount",
            "type": "number",
            "format": ""
        },
        {
            "name": "metadataPreviousVersionsMax",
            "baseName": "metadataPreviousVersionsMax",
            "type": "number",
            "format": ""
        },
        {
            "name": "metadataDeleteAfterCommit",
            "baseName": "metadataDeleteAfterCommit",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "dataRetentionTime",
            "baseName": "dataRetentionTime",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return TableRetentionConfig.attributeTypeMap;
    }
    constructor() {
    }
}
